var Component = require("!../../../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=script&index=0!./tag.vue"),
  /* template */
  require("!!../../../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/template-compiler?id=data-v-1e985586!../../../../../../../../node_modules/_vue-loader@10.3.0@vue-loader/lib/selector?type=template&index=0!./tag.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/select/src/dependencies/packages/tag/src/tag.vue
// module id = 572
// module chunks = 0